import { render, staticRenderFns } from "./image-search-similar.vue?vue&type=template&id=bd374b0a&shadow"
import script from "./image-search-similar.vue?vue&type=script&lang=js&shadow"
export * from "./image-search-similar.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports